import { render, staticRenderFns } from "./PdfRenderer.vue?vue&type=template&id=ba04cd42"
import script from "./PdfRenderer.vue?vue&type=script&lang=js"
export * from "./PdfRenderer.vue?vue&type=script&lang=js"
import style0 from "./PdfRenderer.vue?vue&type=style&index=0&id=ba04cd42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports